import {NgModule} from "@angular/core"
import {ErrorDialogComponent} from "app/common/services/error/dialog/ErrorDialogComponent"
import {ErrorService} from "app/common/services/error/service/ErrorService"
import {MaterialModule} from "app/common/material/MaterialModule"

@NgModule({
    declarations: [
        ErrorDialogComponent
    ],
    entryComponents: [
        ErrorDialogComponent
    ],
    providers: [
        ErrorService
    ],
    imports: [
        MaterialModule
    ]
})
export class ErrorServiceModule {

}
